<template>
  <jade-box
    :title="$t('salesByInstallmentsTitle')"
    hasPadding
    class="flex-1 lg:flex-[2]"
  >
    <template>
      <dash-card-content-fallback :hasData="hasData">
        <jade-text size="small">
          {{ $t('titleNumberTransactions') }}
        </jade-text>

        <chart-bar-installments :data="installments" />
      </dash-card-content-fallback>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeText } from '@jade'
import DashCardContentFallback from '../components/DashCardContentFallback/index.vue'

import InstallmentsManager from './installments.manager'
import ChartBarInstallments from './ChartBarInstallments.vue'

export default {
  name: 'Installments',

  components: {
    JadeBox,
    JadeText,
    ChartBarInstallments,
    DashCardContentFallback
  },

  props: {
    data: {
      type: Array
    }
  },

  computed: {
    hasData () {
      return this.installments?.data?.length > 0 ?? false
    },
    installments () {
      return new InstallmentsManager(this.data).get()
    }
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "salesByInstallmentsTitle": "Quantidade de parcelas em cobranças de cartão de crédito",
    "titleNumberTransactions": "Quantidade de cobranças",
    "salesByInstallmentsDescription": "Quantidade de cobranças por tipo de parcelamento, independente do status final."
  },
  "en-US": {
    "salesByInstallmentsTitle": "Number of installments in credit card transactions",
    "titleNumberTransactions": "Number of transactions",
    "salesByInstallmentsDescription": "Amount of charges by number of installments, regardless of its final status."
  }
}
</i18n>
